<template>
    <div class="st">
        <el-form class="table" v-loading="loading" :model="formData" :rules="formRules" ref="formRef" size="mini">
            <el-form-item class="flex" label="大区名">
                <el-input v-model="formData.vc_region" :disabled="isedit" class="widGD" required　clearable></el-input>
            </el-form-item>
            <el-form-item class="flex"  label="我方公司" >
                <el-select class="widGD"  v-model="formData.vc_company" :disabled="isedit" placeholder="请选择公司" @change="changeCompany($event,'gs')" filterable required >
                    <el-option
                            v-for="item in companyName"
                            :key="item.i_id"
                            :label="item.vc_name"
                            :value="item.i_id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="flex"  label="部门" >
                <el-select class="widGD" :disabled="isedit" @change="changeCompany($event,'bm')" v-model="formData.vc_deptname" :placeholder="$t('form_please_select_department')"  filterable required >
                    <el-option
                            v-for="itembm in groupName"
                            :key="itembm.i_id"
                            :label="itembm.vc_name"
                            :value="itembm.i_id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="flex ys"  label="运输公司" >
                    <input style="padding-left: 14px" v-model="formData.vc_khname" class="widGD_s bor" disabled></input>
                    <!--<el-button  icon="el-icon-search" circle  @click="popShow" size="mini" style="margin-left: 10px"></el-button>-->
                <el-popover
                        class="pop"
                        placement="bottom"
                        width="800"
                        trigger="manual"
                        v-model="visible">
                    <template>
                        <ys-tree v-if="visible==true" @closePop="closePop" @transValue="transValue"></ys-tree>
<!--
                        <product-details v-if="visible==true" :productDetails="productDetails" @closePop="closePop" @transValue="transValue"></product-details>
-->
                    </template>
                    <el-button  class="addbtn" @click="popShow" slot="reference" :disabled="isbtn" ><i class="el-icon-plus"></i></el-button>
                </el-popover>
                <!--<el-popover
                        placement="bottom"
                        title="标题"
                        width="200"
                        trigger="click"
                        content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
                    <el-button slot="reference">click 激活</el-button>
                </el-popover>-->
            </el-form-item>
            <el-form-item class="flex"  label="支付方式" >
                <el-select class="widGD" v-model="formData.vc_payway" :disabled="isedit" placeholder="请选择" @change="changeCompany($event,'zf')" filterable required clearable >
                    <el-option
                            v-for="item in lxdata"
                            :key="item.i_id"
                            :label="item.vc_name"
                            :value="item.i_id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="flex"  label="开始时间" >
                <el-date-picker
                        class="widGD"
                        v-model="formData.dt_starttime"
                        :disabled="isedit"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="选择开始日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item class="flex"  label="结束时间" >
                <el-date-picker
                        class="widGD"
                        v-model="formData.dt_endtime"
                        :disabled="isedit"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="选择结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item class="flex"  label="签订时间" >
                <el-date-picker
                        class="widGD"
                        v-model="formData.dt_signtime"
                        :disabled="isedit"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="选择签订时间">
                </el-date-picker>
            </el-form-item>
            <el-form-item class="flex" label="签订地点">
                <el-input v-model="formData.vc_signaddress" :disabled="isedit" class="widGD" required　clearable></el-input>
            </el-form-item>
            <el-form-item class="flex" label="上传附件">
               <!-- <div>
                    <input type="file" name="files" value="" id="uploadfile1"
                           class="upload-input uploadfile1" @change="uploadFile1">
                </div>-->
                <div class="flex mrb20 img-box">
                    <ul v-if="filejson.signfile.i_fileid!=0" class="uploadPhon flex list" id="formul">
                        <li class="li-img item">
                            <a
                                    :download="filejson.signfile.vc_filename"
                                    mce_href="#"
                                    :href="file_url+'param='+encodeURI('{app:\''+baseApp+'\',i_uid:\''+i_uid+'\',token:\''+token+'\',version:\''+baseVersion+'\',fid:\''+filejson.signfile.vc_filenewname+bht+'\'}','utf-8')">
                                    {{filejson.signfile.vc_filename}}
                            </a>
                            <!-- <i class="el-icon-delete" @click="removeli(oneimg,index)" v-if="commit==false"></i>-->
                        </li>
                    </ul>
                    <div v-if="filejson.signfile.i_fileid==0">
                        <input type="file" name="files" value="" id="uploadfile1" :disabled="isedit"
                               class="upload-input " @change="uploadFile1"  >
                    </div>
                    <!--<div class="upload-box" v-model="formData.imgList">
                        <input type="file" name="files" id="uploadfile1"
                               class="upload-input uploadfile1" @change="upload" style="margin-right: 10px"
                               :disabled="commit">
                        <el-button size="small" type="primary" :class="baseerp+'btn'" :disabled="commit"> 上传附件</el-button>
                    </div>-->
                </div>

            </el-form-item>

            <el-form-item class="flex" label="录入人">
                <el-input v-model="formData.vc_lruname" disabled class="widGD"></el-input>
            </el-form-item>
            <el-form-item class="flex" label="录入时间">
                <el-input v-model="formData.dt_createtime" disabled class="widGD"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer"   class="dialog-footer" style="text-align: center;padding: 6px">
            <el-button type="primary" @click="saveBtn" :disabled="disabled" :class="baseerp+'btn'" size="small">保存</el-button>
            <el-button type="primary"  @click="toApprove" :disabled="disabledsp" :class="disabledsp?(baseerp+'btn'):'redbtn'" size="small">提交审批</el-button>
        </div>
       <!-- <div class="pz" style="text-align: center">
            <el-button class="bcBtn" @click="saveBtn" :class="baseerp+'btn'" size="mini" :disabled="disabled">
                保存
            </el-button>
            <el-button @click="cancel" size="mini">取 消</el-button>
        </div>-->



    </div>

</template>

<script>
    import * as API from  "./../api";
    import {baseerp} from "@/utils/baseUrl";
    import {baseApp} from "@/utils/baseUrl";
    import {file_url} from "@/utils/baseUrl";
    import {baseVersion} from "@/utils/baseUrl";
    import ysTree from "./ysTree";
    export default {
        name: 'StartPlace',
        components: {
            ysTree,
        },
        props:{
          addSP:{
              type: Object,
              required:true,
          }
        },
        data(){
            return{
                loading:false,
                bht:',bht',
                signfile:{},
                isedit:false,
                isbtn:false,
                visible:false,
                token:"",
                i_uid:"",
                baseerp:"",
                file_url: '',
                baseApp:"",
                baseVersion:"",
                lxdata:[],
                companyName:[],
                groupName:[],
                i_id:0,
                formData:{
                    vc_region:"",
                    vc_company:0,//我方公司
                    vc_khname:"",//供方公司
                    vc_payway: "",//支付方式
                    dt_starttime: "",//生效时间
                    dt_endtime: "",//失效时间
                    i_state:0,   //0待提交 3审批中 4已终止 1已生效/审批通过
                    i_gsid:0 ,    //我方公司id
                    i_khid:0 ,   // 运输公司id
                    vc_files:"" ,   //附件对象
                    dt_createtime:"",//录入时间
                    dt_signtime:"",//签订时间
                    vc_signaddress:"",//签订地址
                    uid:"",
                    table:"",// 用于校验
                    busType:"",//审批类型
                    validateCode:"",//用于校验
                    validateKeynames:"",//“i_id,dt_createtime,uid,table,busType”
                    vc_lruname:sessionStorage.getItem("lruname"),
                    i_dept:'',
                    vc_deptname:'',

                },
                filejson:{
                    signfile:{
                        i_fileid:0,
                    },
                },
                dqList:[],
                dqname:'',
                formRules: {
                    xyname: [{required: true, message: "请输入大区", trigger: "change"}],
                    begintime: [{required: true, message: "请选择开始时间", trigger: "change"}],
                    endtime: [{required: true, message: "请选择结束时间", trigger: "change"}],
                },
                disabled:false,
                disabledsp:false,
            }
        },
        mounted() {
            this.baseerp=baseerp;
            this.baseApp = baseApp;
            this.baseVersion = baseVersion;
            this.file_url = file_url;
            this.file=this.file_url;
            this.token=sessionStorage.getItem('token');
            this.i_uid=sessionStorage.getItem('userid');
            //console.log(this.addSP,"-----------")
            let title = this.addSP.title;
            if(title=="新增"){
                //console.log("新增数据");
                this.disabledsp=true;
                this.getCompanyList();
                this.getDictList();
                this.getDateYYYYMMddHHMMSS();
            }else{
                let row = this.addSP.row;
                if(row.i_state==0){
                    this.disabledsp=false;
                }else{
                    this.disabledsp=true;
                    this.disabled=true;
                }
                this.i_id=this.addSP.i_id;
                //console.log("编辑id",this.i_id);
                this.isedit=true;
                this.isbtn=true;
                this.getAgreementDetail();
            }
        },
        methods:{
            toApprove(){
                this.flowSub();
            },
            async flowSub(){
                let state=[3];
                this.loading=true;
                let param={
                    i_id:this.i_id,
                    uid:this.formData.uid,
                    table:this.formData.table,// 用于校验
                    busType:this.formData.busType,//审批类型
                    validateCode:this.formData.validateCode,//用于校验
                    dt_createtime:this.formData.dt_createtime,
                    validateKeynames:this.formData.validateKeynames,//“i_id,dt_createtime,uid,table,busType”
                };
                let res=await API.flowSub(param);
                if(res.code==1){
                    this.loading=false;
                    this.$emit('getAgreementList',state);
                    this.cancel();
                }else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },

            //获取当天日期
            getDateYYYYMMddHHMMSS(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                //return `${date.getFullYear()}-${month}-${strDate}`;
                this.formData.dt_createtime=`${date.getFullYear()}-${month}-${strDate}`;
                this.formData.dt_signtime=`${date.getFullYear()}-${month}-${strDate}`;
            },

            //文件上传
            async uploadFile1(value) {
                this.loading=true;
                let that = this;
                let i = 0;
                let $files = value.target.files[0];
                let fileName = $files.name;
                let type = $files.type;
                var list = {
                    "image/jpeg": true,
                    "image/png": true,
                    "image/jpg": true,
                    "image/bmp": true,
                    "application/pdf": true
                };
                let result = list[type];
                // if(($files && result==false) || ($files &&result==undefined)){
                //     that.$message.error('请上传格式正确的文件');
                //     return;
                // };
                if ($files) {
                    that.fileName = $files.name;
                    that.fileType = $files.type;
                    that.fileUrl = window.URL.createObjectURL(value.target.files[0]);
                } else {
                    that.fileName = "";
                    that.fileType = "";
                    that.fileUrl = "";
                }
                if (that.fileName) {
                    var fileId = 'uploadfile' + that.idNum;
                    var param = {
                        // "file": fileId,
                        // "fileName": that.fileName,
                        // "IDtype": "",
                        // "type": 1,
                        "style": "bht",
                        "files": $files,
                        //"token":sessionStorage.getItem("token"),
                        //"app": "dsmanage",
                        "vc_app": "bht",
                        "i_appid": 0,
                        // "version": "1.0",
                        // "i_uid": sessionStorage.getItem("userid"),
                        "vc_lruname":  sessionStorage.getItem("userid"),
                        "i_lruid": sessionStorage.getItem("userid"),
                        // "i_mid": this.mid
                    };
                    let FD = new FormData();
                    for (let key in param) {
                        FD.append(key, param[key])
                    }
                    let res = await API.upload(param);
                    if (res.code == 1) {
                        // console.log(1)/
                        this.signfile={
                            i_fileid:res.data[0].i_id,
                            vc_name:res.data[0].filename,
                            vc_newname: res.data[0].filenewname,
                            vc_path:res.data[0].vc_path,
                        };
                        //this.upload1()
                        this.loading=false;
                        //console.log("this.signfile",this.signfile)
                    } else if (res.code == -2) {
                        this.loading=false;
                        this.$router.push('/login');
                        this.$message.error(res.message);
                    } else {
                        this.loading=false;
                        this.$message.error(res.message);
                    }
                }
            },
            //产品列表
            transValue(value){
                //console.log("value",value)
                this.formData.vc_khname=value[0].vc_yskhname;
                this.formData.i_khid=value[0].i_yskhid;
            },

            popShow(){
                /*this.productDetails={
                    i_htid:this.i_htid,
                }*/
                //console.log("-----------------------")
                this.visible=true;
                if (this.visible==true){
                    //this.isbtn=true
                }
            },
            closePop(){
                this.visible=false;
                //this.isbtn=false;
            },



            searchData(){
                this.dialogtreeVisibleW=true
            },

            //获取币种等..
            async getDictList() {
                //console.log("val",val)
                let param = {
                    vc_type: "fklx",
                };
                let res = await API.getDictList(param)
                if (res.code == 1) {
                    //console.log(res.data,"data");
                    this.lxdata=res.data;
                } else if (res.code == -2) {
                    this.$navTo('/login');
                    this.$error(res.message);
                } else {
                    this.$error(res.message);
                }

            },

            changeCompany(val,type){
                //console.log("--i_gsid",val)
                //console.log("type",type)
                if(type=="gs"){
                    let obj = this.companyName.find(item => item.i_id == val);
                    this.formData.vc_company=obj.vc_name;
                    this.formData.i_gsid=val;
                    this.groupName=[];
                    this.formData.i_dept=0;
                    this.formData.vc_deptname='';
                    this.getGroupList();
                    this.$forceUpdate()
                }else if(type=='bm'){
                    let obj=this.groupName.find(f=>f.i_id==val);
                    this.formData.i_dept=val;
                    this.formData.vc_deptname=obj.vc_name;
                    this.$forceUpdate()
                }else if(type=="zj"){
                    let obj = this.lxdata.find(item => item.i_id == val);
                    this.formData.vc_payway=obj.vc_name;
                }

            },
            async getGroupList(){
                let param={
                    i_mid: this.mid,
                    i_gsid:this.formData.i_gsid,
                };
                let res=await API.getGroupList(param);
                if(res.code==1){
                    this.groupName=res.data;
                    if(res.data.length==1){
                        this.formData.vc_deptname=res.data[0].vc_name;
                        this.formData.i_dept=res.data[0].i_id;
                    }
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            async getCompanyList(){
                let param={
                    i_mid: this.mid,
                    i_type:"0,2"
                };
                let res=await API.getCompanyList(param);
                if(res.code==1){
                    if (res.data.length>0){
                        this.companyName=res.data;
                        this.formData.vc_company=this.companyName[0].vc_name;
                        this.formData.i_gsid=this.companyName[0].i_id;
                        this.getGroupList()
                    }
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },

            async saveBtn(){
                if (this.formData.vc_region??''!==''){}else {
                    this.$message.error("请输入大区");
                    return ;
                }
                if (this.formData.vc_company??''!==''){}else {
                    this.$message.error("请输入我方公司");
                    return ;
                }
                if (this.formData.vc_deptname??''!==''){}else {
                    this.$message.error("请输入部门");
                    return ;
                }
                if (this.formData.vc_khname??''!==''){}else {
                    this.$message.error("请输入运输公司");
                    return ;
                }
                if (this.formData.vc_payway??''!==''){}else {
                    this.$message.error("请输入支付方式");
                    return ;
                }
                if (this.formData.dt_starttime??''!==''){}else {
                    this.$message.error("请选择开始时间");
                    return ;
                }
                if (this.formData.dt_endtime!==''){}else {
                    this.$message.error("请选择结束时间");
                    return ;
                }
                if (this.formData.dt_signtime!==''){}else {
                    this.$message.error("请选择签订时间");
                    return ;
                }
                if (this.formData.vc_signaddress??''!==''){}else {
                    this.$message.error("请输入签订地点");
                    return ;
                }
                if (this.signfile.i_fileid==0){
                    this.$message.error("请上传附件");
                    return ;
                }
                this.disabled=true;
                let params={
                    i_id:0,
                    vc_region:this.formData.vc_region,
                    vc_company:this.formData.vc_company,//我方公司
                    vc_khname:this.formData.vc_khname,//供方公司
                    vc_payway: this.formData.vc_payway,//支付方式
                    dt_starttime: this.formData.dt_starttime,//生效时间
                    dt_endtime: this.formData.dt_endtime,//失效时间
                    i_gsid:this.formData.i_gsid,    //我方公司id
                    i_khid:this.formData.i_khid,   // 运输公司id
                    i_dept:this.formData.i_dept,
                    vc_deptname:this.formData.vc_deptname,
                    dt_createtime:this.formData.dt_createtime,//录入时间
                    dt_signtime:this.formData.dt_signtime,//签订时间
                    vc_signaddress:this.formData.vc_signaddress,//签订地址
                    table:this.formData.table,// 用于校验
                    uid:this.formData.uid,
                    busType:this.formData.busType,//审批类型
                    validateCode:this.formData.validateCode,//用于校验
                    validateKeynames:this.formData.validateKeynames,//“i_id,dt_createtime,uid,table,busType”
                    filejson:{
                        signfile:this.signfile,
                    }   //附件对象
                };
                //console.log("param",params);
                //return;
                let res=await API.addDbAgreement(params);
                if(res.code==1){
                    /*this.$emit('getAgreementList',state);
                    this.cancel();*/
                    this.i_id=res.i_id;
                    this.getAgreementDetail()
                }else if (res.code == -2) {
                    this.disabled=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.disabled=false;
                    this.$message.error(res.message);
                }
            },

            //详情
            async getAgreementDetail(){
                let params={
                    i_id:this.i_id,
                };
                let res=await API.getAgreementDetail(params);
                if(res.code==1){
                    this.isedit=true;
                    this.isbtn=true;
                    this.i_id=res.data.i_id;//我方公司
                    this.formData.vc_region=res.data.vc_region;
                    this.formData.vc_company=res.data.vc_company;//我方公司
                    this.formData.vc_khname=res.data.vc_khname;//供方公司
                    this.formData.vc_payway=res.data.vc_payway;//支付方式
                    this.formData.dt_starttime=res.data.dt_starttime;//生效时间
                    this.formData.dt_endtime=res.data.dt_endtime;//失效时间
                    this.formData.i_gsid=res.data.i_gsid;//我方公司id
                    this.formData.i_khid=res.data.i_khid;// 运输公司id
                    this.formData.i_dept=res.data.i_dept;
                    this.formData.vc_deptname=res.data.vc_deptname;
                    this.formData.dt_createtime=res.data.dt_createtime;//录入时间
                    this.formData.dt_signtime=res.data.dt_signtime;//签订时间
                    this.formData.vc_signaddress=res.data.vc_signaddress;//签订地址
                    this.formData.uid=res.data.uid;// 用于uid
                    this.formData.table=res.data.table;// 用于校验
                    this.formData.busType=res.data.busType;//审批类型
                    this.formData.validateCode=res.data.validateCode;//用于校验
                    this.formData.validateKeynames=res.data.validateKeynames;//“i_id,dt_createtime,uid,table,busType”
                    this.filejson.signfile=res.data.fileList[0];//附件对象
                    if(res.data.i_state==0){
                        this.disabled=true;
                        this.disabledsp=false;
                    }else{
                        this.disabledsp=true;
                        this.disabled=true;
                    }
                }else if (res.code == -2) {
                    this.disabled=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.disabled=false;
                    this.$message.error(res.message);
                }
            },

            cancel(){
                this.$emit('close')
            },



        },

    }
</script>

<style lang="scss" scoped>
    .redbtn{
        background-color: #fa5050;
        border: #fa5050;
        color: white;
    }
    .img-box{
        width: calc(100% - 85px);
        .item{
            width: 100%;
        }
    }
    .uploadfile1{
        position: absolute;
        opacity: 0;
        top: 6px;
        left: 27px;
        width: 100px;
        height: 80px;
    }
    .wid100{
        width: 100%;
    }
    .bor{
        border: 1px solid #efefef;
        height: 24px;
        margin-right: 12px;
    }

    .flex{
        display: flex;
    }
    .widGD_s{
        width: calc(100% - 101px);
    }
    .widGD{
        width: calc(100% - 85px);
    }
    /deep/.table {
        .el-form-item--mini.el-form-item, .table.el-form-item--small.el-form-item {
            //margin-bottom: 0px;
        }
        .el-form-item__label{
            text-align: left;
            color: #808080;
            min-width: 84px;
            margin-right: 9px;
            padding: 0px !important;
        }
        .el-input--mini .el-input__inner{
            height: 24px;
            line-height: 24px;
        }
        .el-form-item__content{
            width: 100%;
        }
    }
    /deep/.ys .el-form-item__content{
        width: 100%;
        display: flex;
    }
</style>